import React from "react";
import "../../css/my style.css";
import "../../css/my style3.css";
import "../../components/my script";
import Sidenav from "../../components/Sidenav/HTMLSidenav";
import Navbar from "../../components/navbar";
import Footertutorials from "../../components/Footer-tutorials";
import SyntaxHighlighterComponent from "../../components/SyntaxHighlighterComponent";
import ButtonNext from "../../components/Buttonnext";
import ButtonPrevious from "../../components/Buttonprevious";
import Tryitout from "../../components/Tryitoutbutton";
import HTMLMetatag from "../../components/HTML_Metatag";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import ScrollToTopLink from "../../components/ScrollToTop";



export default function HTMLunorderedlist() {
    var newCode = {
        padding: '20px',
        textAlign: 'left',
        background: 'white',
        color: 'black'
        }
        var secondCode = {
            color: 'black'
        }
      const code1 = `
      <!-- Example using the Disc value -->
      <ul type="Disc">
      <li>HTML</li>
      <li>CSS</li>
      <li>JavaScript</li>
      </ul>
  
      <!-- Example using the circle value -->
      <ul type="circle">
      <li>HTML</li>
      <li>CSS</li>
      <li>JavaScript</li>
      </ul>
  
      <!-- Example using the square value -->
      <ul type="square">
      <li>HTML</li>
      <li>CSS</li>
      <li>JavaScript</li>
      </ul>
  `;

    return (
   <body>
     <Helmet>    
        <title>HTML Unordered List</title>
        <meta charset="UTF-8" />
       <meta http-equiv="X-UA-compatible" content="IE-edge"/>
       <meta name="Keywords" content="HTML Unordered Lists, html unordered list, <ul> tag, <li> tag, <ul> tag Attribute, What is an unordered list, What is an <ul> element,
        Step-by-step HTML programming tutorials, HTML coding exercises for beginners, Advanced HTML coding techniques, Best practices for programming beginners, Search Engine Optimization Guide and tips, HTML programming tips for real-world applications," />
       <meta name="description" content="An ordered list is represented by the <ol> element.List that appear with numbers are called ordered list.
       The list items are given the <li> tags." />
       <meta name="viewport" content="width=device-width,initial-scale=1.0" />
      
    </Helmet>
    <br />
        <br />
        <br />
        <br />
        <br />
    <Sidenav />

    <div className="content">
<header className="headertutorials" style={newCode}>
  
<ScrollToTopLink to="/HTML_lists"><ButtonPrevious /></ScrollToTopLink>
<ScrollToTopLink to="/HTML_ordered"><ButtonNext /></ScrollToTopLink>

   <h1 style={secondCode}>HTML Unordered Lists</h1>
</header>

<Navbar />

<main>

<section>
<p>An unordered list is represented by the &lt;ul&gt; element.The &lt;ul&gt; element also represents a list of items where the order is not important.</p>
<p>The list items are given the &lt;li&gt; tags.</p>
<h3>Type Attribute</h3>
<p>The type attribute is used to display which method the list items will take.</p>
<p>The type attribute has the following options for unordered list.</p>
<li>Disc: This value displays a solid round black circle.</li>
<li>circle: This value display a black bordered circle.</li>
<li>square: This value displays a solid square black bullet.</li>
<br />
<h2>Example</h2>
<SyntaxHighlighterComponent code={code1} language="html" />
<ScrollToTopLink to="/try_html57"><Tryitout /></ScrollToTopLink>

</section>
 
<div className="head">
<ScrollToTopLink to="/HTML_lists"><ButtonPrevious /></ScrollToTopLink>
<ScrollToTopLink to="/HTML_ordered"><ButtonNext /></ScrollToTopLink>

</div>

</main>
</div>
<Footertutorials />
   </body>
   
    )
}